<template>
  <BaseList listSubtitulo="Lista de imóveis" :data="imoveis.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="imoveis.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded"
                    @click="abrirModal('tabs', 'info', data.id, data.key)">
              <i class="fa fa-eye"></i> Visualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('tabs', 'edit', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, data.descricao)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarImovel
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarImovel'"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaImoveis"
  />

  <TabsModalImovel
      v-if="modalAtivo === 'tabs'"
      :idModal="'TabsModal'"
      :imovelId=imovelSelect
      :imovelKey="imovelKeySelect"
      :tabSelect="tabSelect"
      @fechar="fecharModal"
      @atualizarImovel="atualizaDadosImovel"

  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarImovel from "./CadastrarImovel.vue";
import TabsModalImovel from "./TabsModalImovel.vue";
import {apiUrl} from "@/router/apiBackRoutes";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";


export default {
  name: "ListaImoveis",
  components: {
    BaseList,
    CadastrarImovel,
    TabsModalImovel,

  },
  emits: ['atualizarImovel'],
  data() {
    return {
      imoveis: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      imovelSelect: null,
      imovelKeySelect: null,
      tabSelect: 'info',
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'descricao', header: 'DESCRIÇÃO',},
        {field: 'tipo_imovel', header: 'TIPO IMÓVEL',},
        {field: 'valor', header: 'VALOR(R$)', align: 'text-right',},
        {field: 'observacao', header: 'OBSERVAÇÃO',},
        {field: 'status', header: 'STATUS', body: row => row.status || '', align: 'text-center',},
      ]
    };
  },
  methods: {
    atualizarListaImoveis(novoImovel) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDadosImovel(imovelAtualizado) {
      const index = this.imoveis.results.findIndex(dado => dado.id === imovelAtualizado.id);
      if (index !== -1) {
        this.imoveis.results[index] = imovelAtualizado;
      }
    },
    abrirModal(tipo, modal = null, id = null, key = null) {
      this.modalAtivo = tipo;
      this.tabSelect = modal
      if (key) {
        this.imovelKeySelect = key;
      }
      if (id) {
        this.imovelSelect = id;
      }

    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(imovelKey, imovelId, imovelDescricao) {
      let url = apiUrl.imoveis.retrieveUpdateDestroy(imovelKey);
      alertDelete(imovelKey, url, 'Você deseja deletar o registro?', `ID: ${imovelId} | ${imovelDescricao}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.imoveis.createList, params);

      if (resultado.success) {
        this.imoveis.results = resultado.data.results || [];
        this.imoveis.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
